import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Footer from '../Footer/Footer';
import classes from './Layout.module.css';
import Navigation from '../Navigation/Navigation';
import Header from '../Header/Header';

const Layout = (props) => {
  const user = useSelector(state => state.user);
  const [isMenuOpen, setIsMenuOpen] = useState(true);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return <>
    {user.username !== '' && <Header onMenuToggle={handleMenuToggle} isMenuOpen={isMenuOpen} />}
    {user && user.username && <div>
      <div className={`${classes['left-panel']} ${!isMenuOpen ? classes['collapsed'] : ''}`}>
        <Navigation isMenuOpen={isMenuOpen} />
      </div>
      <div className={classes['right-panel']} style={{ marginLeft: isMenuOpen ? '250px' : '60px' }}>
        <main className={classes.main}>
          {props.children}
        </main>
        {user.username !== '' && <Footer />}
      </div>
    </div>}

    {!user.username && (
        <div className="bg-login">
          <div className="bl_login">
            <main className={classes.main1}>{props.children}</main>
          </div>
        </div>
      )}
  </>;
};

export default Layout;